<h2 class="">{{ 'form.customerContactForm.heading' | transloco }}</h2>
@if (details$ | async; as details) {
  <form (ngSubmit)="submitForm()" [formGroup]="customerContactForm">
    <div class="select-container">
      <span class="label-content">
        {{ 'form.customerContactForm.subjectSelect.label' | transloco }}
      </span>
      <ng-select
        [ngClass]="{
          isInvalid: $any(customerContactForm.get('re')).invalid,
        }"
        tabindex="0"
        formControlName="re"
        placeholder="{{ 'form.customerContactForm.placeholder' | transloco }}"
        [searchable]="false"
        [markFirst]="true"
        [clearable]="false"
        [items]="details.reList ?? []"
        bindLabel="name"
        bindValue="code"
      >
      </ng-select>
      <boels-form-errors
        [control]="$any(customerContactForm.get('re'))"
        [hide]="!submitted"
      ></boels-form-errors>
    </div>
    <div class="select-container">
      <span class="label-content">
        {{ 'form.customerContactForm.categorySelect.label' | transloco }}
      </span>
      <ng-select
        [ngClass]="{
          isInvalid: $any(customerContactForm.get('category')).invalid,
        }"
        formControlName="category"
        placeholder="{{ 'form.customerContactForm.placeholder' | transloco }}"
        [searchable]="false"
        [markFirst]="true"
        [clearable]="false"
        [items]="details.categoryList ?? []"
        bindLabel="name"
        bindValue="code"
      >
      </ng-select>
      <boels-form-errors
        [control]="$any(customerContactForm.get('category'))"
        [hide]="!submitted"
      ></boels-form-errors>
    </div>
    <boels-textarea
      [maxlength]="2000"
      [label]="'form.customerContactForm.message.label' | transloco"
      [formControl]="$any(customerContactForm.get('message'))"
      class="form-control"
      name="message"
      formControlName="message"
      [required]="true"
      [hideErrors]="!submitted"
    ></boels-textarea>
    <div class="select-container">
      <span class="label-content">
        {{ 'form.customerContactForm.customerType.label' | transloco }}
      </span>
      <ng-select
        [ngClass]="{
          isInvalid: $any(customerContactForm.get('customerType')).invalid,
        }"
        formControlName="customerType"
        placeholder="{{ 'form.customerContactForm.placeholder' | transloco }}"
        [searchable]="false"
        [markFirst]="true"
        [clearable]="false"
        [items]="details.customerTypeList ?? []"
        bindLabel="name"
        bindValue="code"
      >
      </ng-select>
      <boels-form-errors
        [control]="$any(customerContactForm.get('customerType'))"
        [hide]="!submitted"
      ></boels-form-errors>
    </div>
    @if (
      customerContactForm.get('customerType')?.value ===
      (userType.BUSINESS | lowercase)
    ) {
      <boels-text-input
        name="companyName"
        [required]="true"
        [label]="
          'checkout.formPersonalDetails.tradeEntities.companyName' | transloco
        "
        type="text"
        formControlName="companyName"
        [formControl]="$any(customerContactForm.get('companyName'))"
        [hideErrors]="!submitted"
        [maxlength]="80"
      ></boels-text-input>
    }
    <div class="select-container">
      <span class="label-content">
        {{ 'checkout.formBillingShipping.title.label' | transloco }}
      </span>
      <ng-select
        [ngClass]="{
          isInvalid: $any(customerContactForm.get('title')).invalid,
        }"
        formControlName="title"
        placeholder="
            {{ 'form.customerContactForm.placeholder' | transloco }}
            "
        [searchable]="false"
        [markFirst]="true"
        [clearable]="false"
        [items]="details.titleList ?? []"
        bindLabel="name"
        bindValue="code"
      >
      </ng-select>
      <boels-form-errors
        [control]="$any(customerContactForm.get('title'))"
        [hide]="!submitted"
      ></boels-form-errors>
    </div>
    <boels-text-input
      [required]="true"
      name="firstName"
      [label]="'checkout.formBillingShipping.firstName.label' | transloco"
      type="text"
      formControlName="firstName"
      [formControl]="$any(customerContactForm.get('firstName'))"
      [hideErrors]="!submitted"
      [maxlength]="80"
    ></boels-text-input>
    <boels-text-input
      [required]="true"
      name="surname"
      [label]="'checkout.formBillingShipping.surname.label' | transloco"
      type="text"
      formControlName="surname"
      [formControl]="$any(customerContactForm.get('surname'))"
      [hideErrors]="!submitted"
      [maxlength]="80"
    ></boels-text-input>
    <boels-text-input
      [required]="true"
      name="address"
      [label]="'checkout.formBillingShipping.address.label' | transloco"
      type="text"
      formControlName="address"
      [formControl]="$any(customerContactForm.get('address'))"
      [hideErrors]="!submitted"
      [maxlength]="80"
    ></boels-text-input>
    <div class="row">
      <boels-text-input
        class="col col-md-6 col-sm-12"
        [required]="true"
        name="postcode"
        [label]="'checkout.formBillingShipping.zipcode.label' | transloco"
        type="text"
        formControlName="postcode"
        [formControl]="$any(customerContactForm.get('postcode'))"
        [hideErrors]="!submitted"
        [maxlength]="80"
      ></boels-text-input>
      <boels-text-input
        class="col col-md-6 col-sm-12"
        [required]="true"
        name="city"
        [label]="'checkout.formBillingShipping.city.label' | transloco"
        type="text"
        formControlName="city"
        [formControl]="$any(customerContactForm.get('city'))"
        [hideErrors]="!submitted"
        [maxlength]="80"
      ></boels-text-input>
    </div>
    @if (details.countryList?.length !== 0) {
      <div class="select-container">
        <span class="label-content">
          {{ 'checkout.formBillingShipping.country.label' | transloco }}
        </span>
        <ng-select
          [ngClass]="{
            isInvalid: country.invalid,
          }"
          [searchable]="true"
          [clearable]="false"
          [items]="details.countryList ?? []"
          bindLabel="name"
          bindValue="isocode"
          formControlName="country"
        >
        </ng-select>
        <boels-form-errors
          [control]="country"
          [hide]="!submitted"
        ></boels-form-errors>
      </div>
    }
    <div class="phone-container">
      <span class="label-content">
        {{ 'checkout.formBillingShipping.tel.label' | transloco }}
      </span>
      <boels-phone [phoneControl]="telephone"></boels-phone>
      <boels-form-errors
        [control]="$any(customerContactForm.get('telephone'))"
        [hide]="
          !submitted &&
          (!customerContactForm.get('telephone')?.value ||
            customerContactForm.get('telephone')?.value?.number?.length === 0)
        "
      ></boels-form-errors>
    </div>
    <boels-text-input
      [required]="true"
      name="email"
      [label]="'form.customerContactForm.email.label' | transloco"
      type="email"
      formControlName="email"
      [formControl]="$any(customerContactForm.get('email'))"
      [hideErrors]="!submitted"
      [maxlength]="80"
    ></boels-text-input>
    <p
      class="google-recaptcha-notice text-subtle-gray_1000"
      [innerHTML]="'form.googleRecaptcha.notice' | transloco"
    ></p>
    <boels-privacy-statement-link></boels-privacy-statement-link>
    @if ((componentData.data$ | async)?.text; as text) {
      <p>{{ text }}</p>
    }
    <button type="submit" boelsButton [variant]="'primary-brand'" #submitButton>
      {{ 'form.customerContactForm.buttonLabel' | transloco }}
    </button>
  </form>
}
